module.exports = __webpack_public_path__ + "static/card2-0ff01f041e103f775ec8c85492e3b2a3.png";